import { Box, Button, Typography } from '@mui/joy';
import { Phone as PhoneIcon } from '@phosphor-icons/react';
import type { PublicMailerOrganization } from '../../../types/directMail';
import { formatPhoneNumber, telHref } from './brand';
import type { BrandPalette } from './brand';

interface MailerBrandHeaderProps {
  organization: PublicMailerOrganization;
  palette: BrandPalette;
}

export function MailerBrandHeader({ organization, palette }: MailerBrandHeaderProps) {
  return (
    <Box
      component="header"
      sx={{
        bgcolor: 'background.surface',
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Box
        sx={{
          maxWidth: 720,
          mx: 'auto',
          px: { xs: 2, sm: 3 },
          py: 1.5,
          display: 'flex',
          alignItems: 'center',
          gap: 2,
        }}
      >
        {organization.logo_url ? (
          <Box
            component="img"
            src={organization.logo_url}
            alt={organization.name}
            sx={{ height: { xs: 34, sm: 44 }, maxWidth: 200, objectFit: 'contain' }}
          />
        ) : (
          <Typography level="title-lg" sx={{ fontWeight: 800, color: palette.base }}>
            {organization.name}
          </Typography>
        )}

        <Box sx={{ flex: 1 }} />

        {organization.phone && (
          <Button
            component="a"
            href={telHref(organization.phone)}
            size="lg"
            startDecorator={<PhoneIcon size={20} weight="fill" />}
            sx={{
              flexShrink: 0,
              minHeight: 44,
              bgcolor: palette.base,
              color: palette.onBase,
              '&:hover': { bgcolor: palette.base, filter: 'brightness(0.92)' },
            }}
          >
            <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
              {formatPhoneNumber(organization.phone)}
            </Box>
            <Box component="span" sx={{ display: { xs: 'inline', sm: 'none' } }}>
              Call
            </Box>
          </Button>
        )}
      </Box>
    </Box>
  );
}
